<app-menu-common url="stock"></app-menu-common>

@if (formGroup) {
  <div class="flexcolumn">
    <div class="pageheader flexcolumn" [formGroup]="formGroup">
      <div class="flexrow">
        <span class="darker">{{ getTitle() }}</span> <span class="spacer"></span> <span>#{{pinvc_id}}</span>
      </div>
      <div class="left">
        <div>
          <span class="label">Nom</span>&nbsp;<span>{{ formGroup.value.name }}</span>
        </div>
        <div>
          <span class="label">Magasin</span>&nbsp;<span>{{ formGroup.value.store }}</span>
        </div>
        <div class="flexrow">
          <span class="label">Date d'ouverture</span>&nbsp;<span>{{ formGroup.value.datstart | date:'dd/MM/yy':'Local' }}</span><span class="spacer"></span> <span>{{dataSource.data.length}}&nbsp;lignes</span>
        </div>
        @if (zones) {
          <div class="flexrow">
            <span class="label">Zone comptée</span>&nbsp;
            <select [formControl]="currentzone" (change)="onZoneChange($event)">
              <option value="0">-</option>
              @for (z of zones; track z) {
                <option [value]="z.id">{{z.name}}</option>
              }
            </select>
          </div>
        }
      </div>
    </div>
    state: {{state}} Focus: {{focus}} fc_bc: {{ fc_bc.value }}
    @if (currentzone && +currentzone.value !== 0) {
      <div class="bglavander inputzone">
        <input autofocus [formControl]="fc_bc" (keydown)="onKeydownBC($event)" onfocus="this.select()" [cdkTrapFocusAutoCapture]="focus==0" [cdkTrapFocus]="focus==0" style="min-width: 300px;">
        @if ((state==2)) {
          <input [formControl]="fc_note" (keydown)="onKeydownNote($event)" onfocus="this.select()" (blur)="onBlurNote()" placeholder="Désignation libre" [cdkTrapFocusAutoCapture]="focus==1" [cdkTrapFocus]="false">
        }
        @if ((state==1) || (state==2)) {
          <input type="number" id="qty" [formControl]="fc_qty" (keydown)="onKeydownQty($event)" onfocus="this.select()" placeholder="Qté" [cdkTrapFocusAutoCapture]="focus==2" [cdkTrapFocus]="focus==2">
          } <!-- (blur)="onBlurQty()" -->
          @if (state==1) {
            <button id="addbc" type="button" mat-flat-button color="primary" matTooltip="Ajouter" aria-label="Add" (click)="addPincl()">Ajouter</button>
            <span class="productname">{{ product_current?.name }}</span>
          }
          @if (state==2 && fc_bc.value) {
            <span class="productname bcerror">Code barre inconnu. Saisir une désignation libre</span>
          }
          @if (state==2 && !fc_bc.value) {
            <span class="productname bcerror">Code barre vide. Saisir une désignation libre</span>
          }
        </div>
      }
    </div>
  }

  @if (+currentzone.value !== 0) {
    <div class="flexcolumn lightborder">
      @if (dataSource) {
        <div class="pagecontent">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef class="idcol">id</th>
              <td mat-cell *matCellDef="let p" class="idcol">@if (p.product!=0) {
                <span class="productid">#{{ p.product }}</span>
                }@if (p.product==0) {
                <span class="noid">Inexistant</span>
              }</td>
            </ng-container>
            <ng-container matColumnDef="barcode">
              <th mat-header-cell *matHeaderCellDef >[code barre]</th>
              <td mat-cell *matCellDef="let p" class="bc">@if (!p.barcode) {
                <span class="nobc">N/A</span>
                }@if (p.barcode) {
                <span class="darker" [class.noid]="p.product==0" >[{{ p.barcode }}]</span>
              }</td>
            </ng-container>
            <ng-container matColumnDef="productname">
              <th mat-header-cell *matHeaderCellDef>Produit</th>
              <td mat-cell *matCellDef="let p">@if (p.product!=0) {
                <span>{{ p.lnk_product?.name}}</span>
                }@if (p.product==0) {
                <span class="noid">{{ p.note }}</span>
              }</td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef>Qté</th>
              <td mat-cell *matCellDef="let p" class="amount">{{ p.amount }}</td>
            </ng-container>
            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef>Px. TTC</th>
              <td mat-cell *matCellDef="let p" [class.noprice]="!p.lnk_product?.price_taxi" [class.price]="p.lnk_product?.price_taxi">@if (p.product!=0) {
                <span>{{ $safeNavigationMigration(p.lnk_product?.price_taxi) | fc}} @if (!p.lnk_product?.price_taxi) {
                  <mat-icon>warning</mat-icon>
                }</span>
              }</td>
            </ng-container>
            <ng-container matColumnDef="datscan">
              <th mat-header-cell *matHeaderCellDef>Date/Heure scan</th>
              <td mat-cell *matCellDef="let p">{{ p.datscan | date:'dd/MM/yy HH:mm:ss':'Local'}}&nbsp;{{ p.lnk_user.firstname }}&nbsp;{{ p.lnk_user.lastname }}</td>
            </ng-container>
            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef>Util.</th>
              <td mat-cell *matCellDef="let p">{{ p.user }}</td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="idaction">Action</th>
              <td mat-cell *matCellDef="let p" class="idaction">
                <button mat-button color="primary" aria-label="Supprimer un code barre" (click)="deletePinvcl(p)"> <mat-icon>delete</mat-icon> </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row" [class.newrow]="row.indnew"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[50, 100, 200, 500]" showFirstLastButtons aria-label="Page">
          </mat-paginator>
        </div>
      }
    </div>
  }
